import { Badge } from '@/shared/ui/badge'
import { t } from '@/shared/lib/i18n'

interface Props {
  value: number
}

const ComplianceStatusBadge = ({ value }: Props) => {
  if (value === 0) {
    return <Badge variant="destructive">{t('compliance.dashboard.whatHappened.missed')}</Badge>
  }

  if (value === 100) {
    return <Badge variant="secondary">{t('compliance.dashboard.whatHappened.compliant')}</Badge>
  }

  return <Badge variant="warning">{t('compliance.dashboard.whatHappened.partial')}</Badge>
}

export default ComplianceStatusBadge
